import {NgModule} from '@angular/core';
import {CvDownloadPageModule} from './download/cv-download-page.module';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    imports: [CvDownloadPageModule]
})
export class CvPagesModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/cv/cv-pages.module.ts